import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import { CheckIcon } from '@/common/WBSCheckbox';

interface NotificationCheckboxProps {
  checked: boolean;
  onChange: () => void;
}

export function NotificationCheckbox({
  checked,
  onChange,
}: NotificationCheckboxProps) {
  return (
    <CheckboxWrapper>
      <Checkbox checked={checked} onChange={onChange} />
      <CheckmarkIcon icon={faCheck} isVisible={checked} />
    </CheckboxWrapper>
  );
}

const CheckboxWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  position: relative;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: var(--white);
  border: 1.5px solid var(--grey-400);
  border-radius: 3px;
  cursor: pointer;
  flex-shrink: 0;
  height: 20px;
  transition:
    border-color 0.1s,
    background-color 0.1s;
  width: 20px;

  &:checked {
    background-color: var(--wbs-red);
    border: 1.5px solid var(--wbs-red);
  }

  &:focus {
    outline: none;
  }
`;

export const CheckmarkIcon = styled(CheckIcon)<{ isVisible: boolean }>`
  font-size: 12px;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;
